// Shared clipboard helper (2026-11-03): one copy affordance, one toast
// feedback path. Consumers expose it through their Alpine components —
// the CSP build refuses inline handlers, so templ renders the payload
// as a data-* attribute and the click handler reads it off the element.
//
// The async Clipboard API exists ONLY in secure contexts (HTTPS or
// localhost). Bookhoard is routinely opened by bare hostname / LAN IP
// over plain http — there navigator.clipboard is absent and the button
// would always toast failure. Fall back to the classic hidden-textarea
// + execCommand("copy") path (deprecated but universal, CSP-clean) so
// the copy works everywhere (user report 2026-11-03: error toast from
// a real browser on an http hostname).
import { showToast } from "./toast";

export async function copyToClipboard(text: string, description: string): Promise<void> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      showToast(`${description} copied!`, "success");
      return;
    } catch (error) {
      console.error("Clipboard API failed, falling back to execCommand", error);
    }
  }

  // Insecure-context fallback: select-into-a-detached-textarea trick.
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch (error) {
    console.error("execCommand copy failed", error);
  }
  document.body.removeChild(ta);

  if (ok) {
    showToast(`${description} copied!`, "success");
  } else {
    console.error("Failed to copy to clipboard");
    showToast("Failed to copy to clipboard", "error");
  }
}
